<template>
  <div
    style="display:flex; flex-direction: column; justify-content: center; align-items:center;"
  >
    <div ref="listContainer" class="box-container">
      <div v-for="item in visibleItems" :key="item.id" class="box">
        {{ item.customerName }}
      </div>
      <!--      <div v-if="isLoading" class="loading-indicator">Loading...</div>-->
    </div>
    <div style="display:flex; justify-content: center; margin-top:20px;">
      <button
        style="background-color: #0098da; color: white;padding: 10px 20px;"
        @click="loadMore"
        v-if="!allItemsLoaded && !isLoading"
      >
        Load more
      </button>
      <button
        style="background-color: #0098da; color: white;padding: 10px 20px;"
        @click="loadMore"
        v-if="isLoading"
      >
        Loading
      </button>
    </div>
    <!--    <div ref="listContainer" class="list-container">-->
    <!--      <div v-for="item in visibleItems" :key="item.id">-->
    <!--        &lt;!&ndash; Render your items here &ndash;&gt;-->
    <!--        <p>{{ item.name }}</p>-->
    <!--      </div>-->
    <!--      <div v-if="isLoading" class="loading-indicator">Loading...</div>-->
    <!--    </div>-->
  </div>
</template>

<script>
import { mapState } from "vuex";
import StoreUtils from "@/utils/BaseUtils/StoreUtils";
import GroupSessionRequest from "@/model/requests/GroupSessionRequest";

export default {
  name: "SecondTestView",
  data() {
    return {
      items: [], // All items
      visibleItems: [], // Items to be displayed
      itemsPerPage: 8, // Number of items to display per page
      currentPage: 1, // Current page number
      isLoading: false,
      fetchClassesModel: GroupSessionRequest.readAllGroupSessions
    };
  },
  computed: {
    ...mapState({
      professionalDiscover: state => state.professional.professionalsDisplay,
      professionals: state => state.professional.professionals
    }),
    allItemsLoaded() {
      return this.visibleItems.length === this.professionals.length;
    }
    // generateHeight(){
    //   return this.$refs.listContainer.clientHeight;
    // }
  },
  methods: {
    showMore() {
      // this.isLoading = true;
      // this.fetchClassesModel.page = this.currentPage++;
      // this.currentPage++;
      // this.updateVisibleItems();
    },
    loadMore() {
      this.isLoading = true; // Display loading indicator
      this.currentPage++;
      // Increment the page number
      setTimeout(() => {
        this.updateVisibleItems();
      }, 2000);
    },
    updateVisibleItems() {
      // Calculate the range of items to display based on the current page number
      const start = (this.currentPage - 1) * this.itemsPerPage;
      const end = start + this.itemsPerPage;

      // Slice the items array to get the visible items
      this.visibleItems = this.professionals.slice(0, end);
      this.isLoading = false;

      // setTimeout(() => {}, )
      // After rendering the new items, scroll to the last set of loaded items
      this.$nextTick(() => {
        // this.isLoading = false;
        this.scrollToLastLoadedItems();
      });
    },
    scrollToLastLoadedItems() {
      const container = this.$refs.listContainer;
      container.scrollTop = container.scrollHeight;
    },
    handleScroll() {
      const container = this.$refs.listContainer;
      if (
        container.scrollTop + container.clientHeight >=
          container.scrollHeight - 20 &&
        !this.isLoading &&
        !this.allItemsLoaded
      ) {
        this.loadMore();
      }
    }
  },
  mounted() {
    this.$nextTick(() => {
      StoreUtils.dispatch(StoreUtils.actions.professional.READ_PROFESSIONALS);
      this.updateVisibleItems();
    });

    // Add a scroll event listener to trigger loading more items
    window.addEventListener("scroll", this.handleScroll);
  },
  beforeUnmount() {
    // Remove the scroll event listener before component unmounts
    window.removeEventListener("scroll", this.handleScroll);
  }
};
</script>

<style scoped>
.box-container {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  grid-template-rows: 1fr 1fr;
  grid-gap: 10px;
  justify-content: space-between;
  width: 50%;
  margin-top: 50px;
  border: solid 1px red;
  height: 100vh; /* Adjust the height according to your layout */
  overflow-y: auto;
}
.box {
  height: 200px;
  width: 100%;
  border-radius: 10px;
  border: solid 1px blue;
}
.list-container {
  height: 500px; /* Adjust the height according to your layout */
  overflow-y: auto;
}

.loading-indicator {
  text-align: center;
  margin-top: 10px;
}
</style>
